// 后台首页 api
import request from '@/tool/request'

// 首页数据
export function index(query) {
  return request({
    url: 'SignIndex/index',
    method: 'post',
    data:query
  })
}